/* eslint-disable */
export default {
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        getRandomInt(min, max) {
            return Math.floor(Math.random() * (max - min)) + min;
        },
        capitalize(s) {
            if (typeof s !== "string") return "";
            const value = s.charAt(0).toUpperCase() + s.slice(1);
            return value;
        },
        capitalizeFirstLetter(string) {
            const text =
                string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
            return text;
        },
        progress(value) {
            if (value <= 25) {
                this.color = "secondary";
            } else if (value >= 26 && value <= 49) {
                this.color = "purple";
            } else if (value >= 50 && value <= 75) {
                this.color = "accent";
            } else if (value >= 76 && value <= 90) {
                this.color = "blueMedium";
            } else {
                this.color = "green";
            }
            return this.color;
        },
        getUrlActivity(type: any) {

            let url = null;
      
            switch (type) {
              
              // TEXTO
              case "TEXT":
                url = "text";
                break;
            
              // LINK EXTERNO
              case "EXTERNAL_LINK":
                url =  "link-externo"
                break;
              
              // VIDEO LINK
              case "VIDEO_LINK":
                url = "video";
                break
      
              // PDF
              case "FILE": 
                url = "file";
                break 
      
              // LINK EXTERNO EMBEBIDO
              case "EXTERNAL_LINK_EMBEDDED": 
                url = "link-embebido";
                break 
      
              default:
                url = "pdf";
                break;
            }
      
            return url;
          },

        routePush(routeName: String, params: object) {
          // @ts-ignore
          this.$router.push({ name: routeName, params: {...params}})
        }
    }
};
